import React from 'react';
import CalloutFont from '@jbhi-fi/lanyard-ui/font/CalloutFont';
import { removalStyles } from './OldApplianceRemovalSection.css';
import { styles as commonStyles } from './installProductService.css';
import { OldApplianceRemovalSectionProps } from './types';
import BoxRadioGroup from '@jbhi-fi/lanyard-ui/components/BoxRadio/BoxRadioGroup';
import { formatMoney } from '@jbhi-fi/lanyard-ui/global/utils';

const OPTION = {
  REMOVE: 'remove',
  NO: 'no',
};

export const OldApplianceRemovalSection = ({
  applianceLabel,
  price,
  isSelected,
  isDisabled,
  onSelect,
  onDeselect,
}: OldApplianceRemovalSectionProps) => {
  const currentValue = isSelected ? OPTION.REMOVE : '';

  const handleClick = (value: string) => {
    if (isDisabled) return;
    if (value === OPTION.REMOVE) onSelect?.();
    else onDeselect?.();
  };

  const choices = [
    {
      id: 'remove_old_appliance',
      heading: `Remove old ${applianceLabel}`,
      message: `${formatMoney(price)}`,
      name: OPTION.REMOVE,
      value: OPTION.REMOVE,
      onClick: () => {
        if (isDisabled) return;
        onSelect?.();
      },
    },
    {
      id: 'keep_old_appliance',
      heading: 'No thanks',
      message: '',
      name: OPTION.NO,
      value: OPTION.NO,
      onClick: () => {
        if (isDisabled) return;
        onDeselect?.();
      },
    },
  ];

  return (
    <section className={removalStyles.section}>
      <CalloutFont as="h3" className={commonStyles.accessoryHeading}>
        Need your old {applianceLabel} removed?
      </CalloutFont>

      <p className={removalStyles.description}>
        We can take old {applianceLabel}s of a similar type and size away for e-waste recycling.
      </p>

      <BoxRadioGroup
        className={removalStyles.options}
        title=""
        choices={choices}
        currentValue={currentValue}
        handleClick={handleClick}
      >
        {/* no child content */}
        <></>
      </BoxRadioGroup>
    </section>
  );
};
